import SmartGroupSearchIcon from 'Components/common/assets/svgIcons/SmartGroupSearchIcon';
import SmartJobTitleIcon from 'Components/common/assets/svgIcons/SmartJobTitleIcon';
import SmartPeopleSearchIcon from 'Components/common/assets/svgIcons/SmartPeopleSearchIcon';
import {
  SecondaryColorTwo, primaryFont, wMedium,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 46px;
  margin-top: 20px;
  .designation-screen-icon{
    border: 1px solid #EEE;
    border-radius: 7px;
    min-height: 46px;
    min-width: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 16px;
  }
  .designation-screen-text{
    color: ${SecondaryColorTwo};
    font-family: ${primaryFont};
    font-size: 16px;
    font-style: normal;
    font-weight: ${wMedium};
    line-height: normal;
  }
`;

type Props = {
  text: string
  index: number
};

const SmartDesignationLoadingText = function SmartDesignationLoadingText(props: Props) {
  const { text, index } = props;
  const getIcon = (i: number) => {
    switch (i) {
      case 0:
        return <SmartJobTitleIcon />;
      case 1:
        return <SmartPeopleSearchIcon />;
      default:
        return <SmartGroupSearchIcon />;
    }
  };
  return (
    <Wrapper>
      <span className="designation-screen-icon">{getIcon(index)}</span>
      <span className="designation-screen-text">{text}</span>
    </Wrapper>
  );
};

export default SmartDesignationLoadingText;
